enum GtmPageviewTitleId {
    HOMEPAGE_FACELIFT = 'HOMEPAGE_FACELIFT',
    HOMEPAGE_DOGORAMA = 'HOMEPAGE_DOGORAMA',
    HOMEPAGE = 'HOMEPAGE',
    PAGE_IHR_TIER = 'PAGE_IHR_TIER',
    PAGE_ANGEBOT = 'PAGE_ANGEBOT',
    PAGE_ANTRAG = 'PAGE_ANTRAG',
    PAGE_EINGEREICHT = 'PAGE_EINGEREICHT'
}

export default GtmPageviewTitleId